export default __webpack_public_path__ + "static/media/SARA-SOCAS.4329215e.png";